var _circle, _ellipse, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _ellipse2, _path, _path2, _path3, _ellipse3, _ellipse4, _ellipse5, _path4, _ellipse6, _ellipse7, _path5, _circle9, _circle10, _circle11, _circle12, _ellipse8, _ellipse9, _ellipse10, _path6, _ellipse11, _ellipse12, _ellipse13, _path7, _ellipse14, _ellipse15, _ellipse16, _path8, _circle13, _circle14, _circle15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCookie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#9F5448"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11,
    cy: 12.5,
    rx: 10,
    ry: 11.5,
    fill: "url(#paint0_linear_6_114)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12,
    stroke: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 6.5,
    r: 0.5,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 10.5,
    r: 0.5,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 22.5,
    r: 0.5,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 18.5,
    r: 0.5,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 19.5,
    r: 0.5,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 5.5,
    r: 0.5,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.056,
    cy: 1.57136,
    rx: 2.056,
    ry: 1.57136,
    transform: "matrix(-0.189897 -0.981804 0.984753 -0.173959 2.64606 18.5408)",
    fill: "#FBC4BE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.76512 14.9053C4.53183 14.7687 5.27319 15.2724 5.421 16.0304C5.56881 16.7884 5.06709 17.5137 4.30038 17.6503C3.53368 17.7869 2.79232 17.2832 2.64451 16.5252C2.4967 15.7672 2.99841 15.042 3.76512 14.9053Z",
    fill: "#B55D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.89216 14.8827C4.5887 14.7586 5.23598 15.0816 5.33789 15.6042C5.4398 16.1268 4.95775 16.6511 4.26121 16.7753C3.56466 16.8994 2.91739 16.5763 2.81548 16.0537C2.71357 15.5311 3.19561 15.0068 3.89216 14.8827Z",
    fill: "#8F4E45"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28994 17.6759C6.18423 18.3938 5.76313 13.7889 3.92445 15.0677",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.056,
    cy: 1.57136,
    rx: 2.056,
    ry: 1.57136,
    transform: "matrix(0.892852 -0.450351 0.435821 0.900033 15.2825 9.76053)",
    fill: "#FBC4BE"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.39832,
    cy: 1.41011,
    rx: 1.39832,
    ry: 1.41011,
    transform: "matrix(0.892163 -0.451713 0.437171 0.899378 15.9738 9.84119)",
    fill: "#B55D51"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.09518,
    cy: 1.32771,
    rx: 1.09518,
    ry: 1.32771,
    transform: "matrix(0.892163 -0.451713 0.437171 0.899378 16.0458 9.98941)",
    fill: "#8F4E45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5628 11.1064C16.3884 13.1246 20.7042 11.4641 18.9725 10.0437",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.056,
    cy: 1.57136,
    rx: 2.056,
    ry: 1.57136,
    transform: "matrix(0.889389 -0.457151 0.442677 0.896681 8.27881 19.7798)",
    fill: "#FBC4BE"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.39832,
    cy: 1.41011,
    rx: 1.39832,
    ry: 1.41011,
    transform: "matrix(0.88869 -0.458508 0.444022 0.896016 8.9707 19.8552)",
    fill: "#B55D51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.56933 21.1158C9.4104 23.1353 13.7134 21.4419 11.9709 20.0348",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.1254,
    cy: 13.5,
    r: 0.5,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 18.5,
    r: 0.5,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 6.5,
    r: 0.5,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 8.5,
    r: 0.5,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.61677,
    cy: 1.24362,
    rx: 1.61677,
    ry: 1.24362,
    transform: "matrix(0.84749 -0.530812 0.506425 0.862284 3.62537 8.7164)",
    fill: "#FBC4BE"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.09962,
    cy: 1.11599,
    rx: 1.09962,
    ry: 1.11599,
    transform: "matrix(0.846673 -0.532113 0.507711 0.861528 4.17032 8.733)",
    fill: "#B55D51"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.720676,
    cy: 0.515915,
    rx: 0.720676,
    ry: 0.515915,
    transform: "matrix(0.846673 -0.532113 0.507711 0.861528 4.77963 9.76697)",
    fill: "#8F4E45"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.71524 9.69391C4.71524 11.3029 7.97142 9.69391 6.52423 8.68826",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.056,
    cy: 1.57136,
    rx: 2.056,
    ry: 1.57136,
    transform: "matrix(-0.189897 -0.981804 0.984753 -0.173959 9.64606 7.5408)",
    fill: "#FBC4BE"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.39832,
    cy: 1.41011,
    rx: 1.39832,
    ry: 1.41011,
    transform: "matrix(-0.191395 -0.981513 0.984491 -0.175437 9.91211 6.89767)",
    fill: "#B55D51"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.9641,
    cy: 1.28106,
    rx: 0.9641,
    ry: 1.28106,
    transform: "matrix(-0.191395 -0.981513 0.984491 -0.175437 10 6)",
    fill: "#8F4E45"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2899 6.67591C13.1842 7.39384 12.7631 2.78887 10.9245 4.06774",
    stroke: "black",
    strokeLinecap: "round"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.056,
    cy: 1.57136,
    rx: 2.056,
    ry: 1.57136,
    transform: "matrix(0.239075 0.971001 -0.974748 0.223307 11.8432 11.9016)",
    fill: "#FBC4BE"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.39832,
    cy: 1.41011,
    rx: 1.39832,
    ry: 1.41011,
    transform: "matrix(0.240557 0.970635 -0.974412 0.224769 11.6098 12.5573)",
    fill: "#B55D51"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.805995,
    cy: 0.75874,
    rx: 0.805995,
    ry: 0.75874,
    transform: "matrix(0.240557 0.970635 -0.974412 0.224769 11.104 14)",
    fill: "#8F4E45"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2449 12.8481C8.31686 12.2265 8.96922 16.8044 10.7412 15.4346",
    stroke: "black",
    strokeLinecap: "round"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.1254,
    cy: 17.5,
    r: 0.5,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.1254,
    cy: 15.5,
    r: 0.5,
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1254,
    cy: 15.5,
    r: 0.5,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_114",
    x1: 18.1429,
    y1: 4.68,
    x2: 5.85984,
    y2: 22.1047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0988A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A574F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookie);
export default __webpack_public_path__ + "static/media/cookie.3aba7b6192a5b32189ea81ed7d83d62a.svg";
export { ForwardRef as ReactComponent };